<script>
import { mapState } from 'vuex';
import HomeBanner from '../components/homeBanner.vue';
import HomeListSwiper from '../components/homeListSwiper.vue';
import HomeProductSwiper from '../components/homeProductSwiper.vue';

export default {
    name: "home",
    data() {
        return {};
    },
    computed: {
        ...mapState(['homeData']),
    },
    components: {
        HomeBanner,
        HomeListSwiper,
        HomeProductSwiper
    },
    mounted() {
        this.$store.dispatch('getHome')
    },
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="home">
        <HomeBanner :data="homeData.banner"/>
        <!-- 娱乐商务/艺术授权 -->
        <div class="layout_main flex justify_between images_group">
            <div class="images">
                <div class="title">娱乐商务</div>
                <div class="wrapper flex flex_wrap">
                    <div class="item type1" v-for="(item, index) in homeData.entertainment" :key="index">
                        <HomeListSwiper :data="item.image" :name="item.name"/>
                    </div>
                </div>
                <div class="all_list">
                    <HomeListSwiper :data="homeData.entertainmentAll"/>
                </div>
                <div class="btn_more"><a :href="homeData.entertainment_link">了解更多</a></div>
            </div>
            <div class="images">
                <div class="title">艺术授权</div>
                <div class="wrapper flex flex_wrap">
                    <div class="item type2" v-for="(item, index) in homeData.art_licensing" :key="index">
                        <HomeListSwiper :data="item.image"/>
                    </div>
                </div>
                <div class="all_list">
                    <HomeListSwiper :data="homeData.art_licensingAll"/>
                </div>
                <div class="btn_more"><a :href="homeData.art_licensing_link">了解更多</a></div>
            </div>
        </div>
        <!-- 艺术商店 -->
        <div class="layout_main shop" v-if="homeData.goods.length > 0">
            <div class="title">艺术商店</div>
            <div class="shop_swiper">
                <HomeProductSwiper :data="homeData.goods"/>
                <div class="btn"><router-link to="/shop">立即购买</router-link></div>
            </div>
            <div class="shop_list_wrapper">
                <div class="list flex flex_wrap">
                    <router-link class="item" v-for="(item, index) in homeData.goods" :key="index" :to="`/shop/detail?id=${item.id}`" v-if="index < 4">
                        <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                        <div class="name">{{ item.name }}</div>
                        <div class="price">RMB {{ item.price }}</div>
                    </router-link>
                </div>
                <div class="btn"><router-link to="/shop">立即购买</router-link></div>
            </div>
        </div>
        <!-- 画廊 -->
        <div class="layout_main gallery" v-if="false">
            <div class="title">画廊</div>
            <div class="list flex justify_between">
                <div class="item" v-for="(item, index) in homeData.new_exhibition" :key="index">
                    <div class="cover">
                        <HomeListSwiper :data="item.image" name=""/>
                        <div class="name position_center text_shadow">{{ item.name }}</div>
                    </div>
                    <div class="btn text_shadow">{{ item.button_name }}</div>
                </div>
            </div>
            <div class="gallery_list">
                <HomeListSwiper :data="homeData.new_exhibitionAll"/>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.home{
    background: var(--home_bg);
    color: #fff;
    padding-bottom: 1rem;
    .title{
        text-align: center;
        font-size: .25rem;
        margin: .4rem 0;
        @media only screen and (max-width: 750px) {
            font-size: .28rem;
            margin: .6rem 0 .4rem;
        }
    }
}
.images_group{
    gap: .15rem;
    @media only screen and (max-width: 750px) {
        flex-direction: column;
        width: 100%;
    }
    .images{
        position: relative;
        .btn_more{
            font-size: .16rem;
            text-align: center;
            margin: .3rem 0 .1rem;
            @media only screen and (max-width: 750px) {
                position: absolute;
                left: 50%;
                transform: translate(-50%, 0);
                bottom: 1.2rem;
                z-index: 1;
                font-size: .22rem;
            }
        }
        .all_list{
            display: none;
            @media only screen and (max-width: 750px) {
                display: block;
                width: 100%;
                height: 7.45rem;
            }
        }
        .wrapper{
            @media only screen and (max-width: 750px) {
                // flex-direction: column;
                display: none;
            }
            .item{
                height: 2.47rem;
                // @media only screen and (max-width: 750px) {
                //     width: 100% !important;
                //     height: 7.45rem;
                // }
                &.type1{
                    &:nth-of-type(1){
                        width: 3.15rem;
                    }
                    &:nth-of-type(2){
                        width: 2.77rem;
                    }
                    &:nth-of-type(3){
                        width: 2.48rem;
                    }
                    &:nth-of-type(4){
                        width: 3.44rem;
                    }
                }
                &.type2{
                    &:nth-of-type(1){
                        width: 2.97rem;
                    }
                    &:nth-of-type(2){
                        width: 2.93rem;
                    }
                    &:nth-of-type(3){
                        width: 1.78rem;
                    }
                    &:nth-of-type(4){
                        width: 2.32rem;
                    }
                    &:nth-of-type(5){
                        width: 1.8rem;
                    }
                }
            }
        }
    }
}
.shop{
    .shop_swiper{
        background: #2b2b2b;
        padding: .4rem 0;
        @media only screen and (max-width: 750px) {
            display: none;
        }
        .btn{
            font-size: .16rem;
            text-align: center;
            margin-top: .3rem;
        }
    }
    .shop_list_wrapper{
        display: none;
        @media only screen and (max-width: 750px) {
            display: block;
            .list{
                gap: .3rem .2rem;
                .item{
                    width: 3.35rem;
                    display: block;
                    text-align: center;
                    .cover{
                        height: 0;
                        padding-bottom: 100%;
                        margin-bottom: .3rem;
                    }
                    .name{
                        font-size: .26rem;
                        margin-bottom: .2rem;
                    }
                    .price{
                        font-size: .22rem;
                    }
                }
            }
            .btn{
                font-size: .22rem;
                text-align: center;
                margin-top: .5rem;
            }
        }
    }
}
.gallery{
    @media only screen and (max-width: 750px) {
        width: 100%;
    }
    .gallery_list{
        display: none;
        @media only screen and (max-width: 750px) {
            display: block;
            width: 100%;
            height: 7.45rem;
        }
    }
    .list{
        gap: .21rem;
        @media only screen and (max-width: 750px) {
            display: none;
        }
        .item{
            flex: 1;
            // width: 3.86rem;
            // height: 3.86rem;
            position: relative;
            .cover{
                width: 100%;
                padding-bottom: 100%;
                position: relative;
                .home_list_swiper{
                    position: absolute;
                }
                .name{
                    font-size: .24rem;
                    z-index: 1;
                }
            }
            .btn{
                font-size: .16rem;
                text-align: center;
                margin-top: .3rem;
            }
        }
    }
}
</style>